@if (loading()) {
  <span class="autocomplete-empty-message">
    <i class="pi pi-spin pi-spinner" aria-hidden="true"></i> Searching…
  </span>
} @else {
  <span class="autocomplete-empty-message">{{ text() }}</span>
}
